<template>
  <div class="security-setting-page">
    <salary-security-manage :visible="true" @close="handleClose" @success="handleSuccess" />
  </div>
</template>

<script>
import SalarySecurityManage from './index.vue'

export default {
  name: 'SalarySecuritySetting',
  components: { SalarySecurityManage },
  methods: {
    handleClose () {
      this.$router.back()
    },
    handleSuccess () {
      this.$router.back()
    }
  }
}
</script>

<style scoped>
.security-setting-page {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/salary/security/setting.vue